import type { ThemeMode } from '@/hooks/useLightMode'

import { tokenPrefix } from '@hivewatch/dark'

import { getIncidentSurfaceTokens } from '@/utils/incidentSurfaceTokens'

/**
 * Dark-package semantic tokens for the incoming-alert notification toasts.
 * Extends the shared incident-surface base (`getIncidentSurfaceTokens`) with
 * the toast severity accents, so the toasts and the inbox cards read as one
 * system in both light and dark mode.
 */
export const getNotificationToastTokens = (mode: ThemeMode) => {
  const p = tokenPrefix(mode) // '' | 'light.'
  return {
    ...getIncidentSurfaceTokens(mode),
    // Severity accents for the left bar / icon: danger for new & flagged
    // incidents, resolved for cleared incidents.
    danger: `${p}status.error`,
    shadow: mode === 'light' ? 'card-light' : 'card',
    success: `${p}status.resolved-text`,
  }
}
